// The Whop Pixel bootstrap, copied verbatim from the ad network's single
// definition. Every installed snippet must be built from this exact text or
// the collector cannot attribute the events.
const PIXEL_BOOTSTRAP = "!function(w,d,s,u,n,a,b){if(w[n])return;a=w[n]={q:[],t:+new Date,s:[],o:u,track:function(){a.q.push([+new Date].concat([].slice.call(arguments)))},setScope:function(){a.s=[].slice.call(arguments).filter(function(x){return typeof x===\"string\"});a.q.push([+new Date,\"setScope\"].concat(a.s))},scope:function(){var c=[].slice.call(arguments);return{track:function(){a.q.push([+new Date].concat([].slice.call(arguments)).concat([{__scope:c}]))}}}};b=d.createElement(s);b.async=1;b.src=u+\"/s.js\";d.getElementsByTagName(s)[0].parentNode.insertBefore(b,d.getElementsByTagName(s)[0])}(window,document,\"script\",[\"https://t.wh\",\"op.tw\"].join(\"\"),[\"wh\",\"op\"].join(\"\"));";

function scriptStringLiteral(value: string): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}

// The SDK boots from the vendor's global and reassigns its methods on that same
// object, so an alias created right after the bootstrap keeps working after the
// script loads. Clients only ever see and type `oxwell.*`.
export const PIXEL_ALIAS = "window.oxwell=window[[\"wh\",\"op\"].join(\"\")];";

export function pixelInlineScript(accountId: string): string {
  return `${PIXEL_BOOTSTRAP}whop.setScope(${scriptStringLiteral(accountId)});${PIXEL_ALIAS}oxwell.track("page");`;
}

export function pixelSnippet(accountId: string): string {
  return `<script>${pixelInlineScript(accountId)}</script>`;
}

export function trackSnippet(eventName: string): string {
  return `oxwell.track(${scriptStringLiteral(eventName)});`;
}

// The same snippet laid out for reading: bootstrap plus scope on one line, the
// alias and the page call on their own lines. Whitespace is free in HTML/JS, so
// pasting either form installs the same pixel.
export function pixelSnippetPretty(accountId: string): string {
  return `<script>\n${PIXEL_BOOTSTRAP}whop.setScope(${scriptStringLiteral(accountId)});\n${PIXEL_ALIAS}\noxwell.track("page");\n</script>`;
}
